import React from 'react';
import Img from 'gatsby-image';
import './Quotes.scss';
import { Container } from '../../UI/Container/Container';
import { PrismicHTMLParser } from '../../PrismicHTMLParser';
import { Carousel } from '../../UI/Carousel';
import { Arrow } from '../../Icons';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import { get } from '../../../helpers';
import { FluidGatsbyImageFieldType } from '../types';

type Quote = {
    quotes_text: {
        html: string | null;
    };
    quotes_image: FluidGatsbyImageFieldType;
    quotes_author: string | null;
    quotes_description: string | null;
};

type QuotesProps = {
    slice_type: 'quotes';
    slice: {
        items: Quote[];
    };
};

const Quote = ({ quote }: { quote: Quote }) => {
    const imgSizes = get(['quotes_image', 'localFile', 'childImageSharp', 'sizes'], quote);
    return (
        <div className="Quotes-item">
            <PrismicHTMLParser className="Quotes-item-text">
                {quote.quotes_text.html}
            </PrismicHTMLParser>
            <div className="Quotes-item-author">
                {imgSizes && (
                    <Img
                        className="Quotes-item-authorImage"
                        sizes={imgSizes}
                        alt={quote.quotes_author ? quote.quotes_author : ''}
                    />
                )}
                <div>
                    <span className="Quotes-item-authorName">{quote.quotes_author}</span>
                    <span className="Quotes-item-authorDescription">
                        {quote.quotes_description}
                    </span>
                </div>
            </div>
        </div>
    );
};

const Quotes = ({ slice }: QuotesProps) => {
    const { items } = slice;
    return (
        <Container size="md">
            <Grid className="Quotes">
                {items.length > 1 ? (
                    <Carousel
                        theme="dark"
                        carouselConfig={{
                            autoplay: false,
                            slidesToShow: 1,
                            wrapAround: true,
                            renderCenterLeftControls: ({ previousSlide }) => (
                                <button
                                    onClick={previousSlide}
                                    className="Quotes-carouselButton Quotes-carouselButton--left"
                                    aria-label="Go to previous slide"
                                >
                                    <Arrow size="large" />
                                </button>
                            ),
                            renderCenterRightControls: ({ nextSlide }) => (
                                <button
                                    onClick={nextSlide}
                                    className="Quotes-carouselButton Quotes-carouselButton--right"
                                    aria-label="Go to next slide"
                                >
                                    <Arrow size="large" />
                                </button>
                            ),
                        }}
                    >
                        {items.map((quote: Quote, i: number) => (
                            <Container size="lg" key={i}>
                                <GridRow horizontalAlign={'h-start'} verticalAlign={'v-stretch'}>
                                    <GridCol colSize={'12'} offsetSize={`0`} mobileColSize={'12'}>
                                        <Quote quote={quote} />
                                    </GridCol>
                                </GridRow>
                            </Container>
                        ))}
                    </Carousel>
                ) : (
                    items.map((quote: Quote, i: number) => (
                        <Container size="lg" key={i}>
                            <GridRow horizontalAlign={'h-start'} verticalAlign={'v-stretch'}>
                                <GridCol colSize={'12'} offsetSize={`0`} mobileColSize={'12'}>
                                    <Quote quote={quote} />
                                </GridCol>
                            </GridRow>
                        </Container>
                    ))
                )}
            </Grid>
        </Container>
    );
};

export { Quotes, QuotesProps, Quote };
